import { render } from "./index.vue?vue&type=template&id=316e8ce1&scoped=true&ts=true"
import script from "./view-model/index.ts?vue&type=script&lang=ts"
export * from "./view-model/index.ts?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=316e8ce1&lang=less&scoped=true"

import exportComponent from "D:\\code\\customer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316e8ce1"],['__file',"src/components/main-layout/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "316e8ce1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('316e8ce1', __exports__)) {
    console.log('reload')
    api.reload('316e8ce1', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=316e8ce1&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('316e8ce1', render)
  })

}


export default __exports__